import SUPPORTED_CODE_LANGS_JSON from '#src/data/supported-code-langs.json' with {type: 'json'};

export const MarkupBBCodeVariant = {
  Long: 'long',
  Short: 'short'
};

export const MarkupFlavour = {
  BBCode: 'bbcode',
  Markdown: 'markdown'
};

export const MarkupLatexType = {
  Block: 'block',
  Inline: 'inline'
};

export const MarkupMarkdownVariant = {
  Asterisk: 'asterisk',
  Slash: 'slash',
  Underscore: 'underscore'
};

export const MarkupNodeType = {
  Bold: 'bold',
  Code: 'code',
  CollapsibleSpoiler: 'collapsible-spoiler',
  Command: 'command',
  Italics: 'italics',
  Latex: 'latex',
  LineBreak: 'line-break',
  Link: 'link',
  ListItem: 'list-item',
  Monospace: 'monospace',
  NoMarkup: 'no-markup',
  OrderedList: 'ordered-list',
  PostLink: 'post-link',
  Preformatted: 'preformatted',
  Quotation: 'quotation',
  Spoiler: 'spoiler',
  Strikethrough: 'strikethrough',
  Subscript: 'subscript',
  Superscript: 'superscript',
  Text: 'text',
  Tooltip: 'tooltip',
  Underlined: 'underlined',
  UnorderedList: 'unordered-list'
};

export const MarkupUnorderedListType = {
  Circle: 'circle',
  Disc: 'disc',
  Square: 'square'
};

export const HTML_TAG_LINE_BREAK = `<div data-type="${MarkupNodeType.LineBreak}"/>`;

export const MARKUP_NODE_TYPE_ROOT = 'root';

export const SUPPORTED_CODE_LANGS = SUPPORTED_CODE_LANGS_JSON.items;
